import axios from 'axios';

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/support`;
//const BASE_URL = 'http://localhost:8085';

const config = {
	withCredentials: true,
	headers: { 'Content-Type': 'application/json' },
};

export class MicrosoftApi {
	static getCalendarView(params) {
		const url = `${BASE_URL}/calendar/view`;

		return axios.post(url, params, config);
	}

	static createEvent(params) {
		const url = `${BASE_URL}/events/create`;

		return axios.post(url, params, config);
	}

	static createEventRequest(params) {
		const url = `${BASE_URL}/events/create/request`;

		return axios.post(url, params, config);
	}

	static getAvailableMeetingSlots(params) {
		const url = `${BASE_URL}/calendar/available`;

		return axios.post(url, params, config);
	}
	static updateEvent(params) {
		const url = `${BASE_URL}/events/update`;

		return axios.post(url, params, config);
	}
	static getEvent(params) {
		const url = `${BASE_URL}/events/event`;

		return axios.post(url, params, config);
	}

	static cancelEvent(id) {
		const params = { eventId: id };
		const url = `${BASE_URL}/events/cancel`;

		return axios.post(url, params, config);
	}

	//One Drive endpoints
	static getOneDrive() {
		const url = `${BASE_URL}/files/drive`;
		return axios.get(url, config);
	}
	static getOneDriveItem(params) {
		const url = `${BASE_URL}/files/folder`;
		return axios.post(url, params, config);
	}
	static getFileRequest(params) {
		const url = `${BASE_URL}/files/send`;
		return axios.post(url, params, config);
	}
	static getOrgOneDriveItem(id) {
		const url = `${BASE_URL}/files/org/${id}`;
		return axios.get(url, config);
	}
}
